import styled from "styled-components";

import {
	SwapArrow,
	SwapButton,
	SwapCardContainer,
	SwapInput,
	SwapInputsContainer,
	type Token,
} from "@components";

import {
	Tooltip,
	Typography,
} from "@bracket/ui";


import type {
	TokenDefinition,
} from "@bracket/chainography";




export const SwapCard = () => {

	const hasInsufficientBalance = false;
	const isButtonDisabled = false;

	const inputToken: TokenDefinition = {
		chainId: 1,
		address: "0x0",
		name: "LRT",
		label: "LRT",
		symbol: "LRT",
		decimals: 18,
		logoURI: "",
		parity: true,
	};

	const tokens: Token[] = [];
	const inputAmount = "0";
	const inputBalance = 0;
	const handleInputAmountChange = () => {};
	const handleTokenChange = () => {};
	const outputAmount = "0";

	return (
		<SwapCardContainer>
			<SectionHeaderContainer>
				<Typography variant="h5" color="var(--text-heading-title)">
					Burn brktETH
				</Typography>

				<Typography variant="paragraphMD" color="var(--text-subheading)">
					brktETH → LST
				</Typography>
			</SectionHeaderContainer>

			<BalanceContainer>
				<BalanceTitleContainer>
					<Typography variant="paragraphMD" color="var(--text-subheading)">
						brktETH Balance
					</Typography>

					<Tooltip message="text" />
				</BalanceTitleContainer>

				<Typography variant="h2" color="var(--text-heading-title)">
					5.0
				</Typography>
			</BalanceContainer>

			<SwapInputsContainer>
				<SwapInput
					inputName="Enter amount"
					inputAmount={inputAmount}
					token={inputToken}
					tokens={tokens}
					inputBalance={{
						decimals: 18,
						formatted: inputBalance.toString(),
						symbol: inputToken.symbol,
						value: BigInt(inputBalance),
					}}
					handleInputAmountChange={handleInputAmountChange}
					handleTokenChange={handleTokenChange}
				/>

				<SwapArrow isReversed={false} onClick={() => {}} />

				<SwapInput
					inputName="Asset"
					inputAmount={outputAmount}
					token={inputToken}
					tokens={tokens}
					inputBalance={{
						decimals: 18,
						formatted: "0",
						symbol: inputToken.symbol,
						value: BigInt(0),
					}}
					handleInputAmountChange={() => {}}
					handleTokenChange={() => {}}
					disabled
				/>
			</SwapInputsContainer>

			<SwapButton
				handleClick={async () => {}}
				isDisabled={isButtonDisabled}
				label={
					hasInsufficientBalance
						? "Exceeds your balance"
						: `Burn ${inputToken.symbol}`
				}
			/>
		</SwapCardContainer>
	);
};

const SectionHeaderContainer = styled.div`
	display: flex;
	justify-content: space-between;
`;

const BalanceContainer = styled.div`
	display: flex;
	gap: 8px;
	flex-direction: column;
`;

const BalanceTitleContainer = styled.div`
	display: flex;
	gap: 8px;
`;
